export const API = 'http://localhost:8080/';
export const BASE_MODEL_ENDPOINT = 'base_mode';
export const ROLLBACK_TRUE = '1';
export const ROLLBACK_FALSE = '0';
